<template>
  <div class="seekDatePicker m-r-30 mtable-tool-seek">
    <Dropdown>
      <input name="startDate" v-validate="'required|date_format:YYYY-MM-DD'" class="form-control input-date input-date1" type="text" v-model='seekDatePicker.startDate' @keyup.enter="emitSeek" col-lg-12 ref='birth_date' :placeholder="seekLan.err.dateFormat">
      <button class="btn btn-default date date1" type="button" data-role="trigger">
        <i class="glyphicon glyphicon-calendar"></i>
      </button>
      <template slot="dropdown">
        <li>
          <DatePicker class="date-picker" v-model="seekDatePicker.startDate" :format="'yyyy-MM-dd'" :close-on-selected="true"></DatePicker>
        </li>
      </template>
    </Dropdown>
    <Dropdown>
      <input name="endDate" v-validate="testStopDate" class="form-control input-date" type="text" v-model='seekDatePicker.endDate' @keyup.enter="emitSeek" col-lg-12 ref='birth_date' :placeholder="seekLan.err.dateFormat">
      <button class="btn btn-default date" type="button" data-role="trigger">
        <i class="glyphicon glyphicon-calendar"></i>
      </button>
      <template slot="dropdown">
        <li>
          <DatePicker class="date-picker" v-model="seekDatePicker.endDate" :format="'yyyy-MM-dd'" :close-on-selected="true"></DatePicker>
        </li>
      </template>
    </Dropdown>
    <div class="btn btn-default btn-primary" @click="emitSeek">{{seekLan.seek}}</div>
  </div>
</template>

<script>
  import { Dropdown, DatePicker } from "uiv"
  import { mapState } from "vuex"

  export default {
    props: [
      "seekDatePicker"
    ],
    data () {
      return {
        formModel: {
          startDate: "",
          stopDate: ""
        }
      }
    },
    mounted () {
      this.getDate()
    },
    computed: {
      seekLan () {
        return this.translate(this.LANGUAGE, "seek")
      },
      testStopDate () {
        return "required|date_format:YYYY-MM-DD"
      },
      ...mapState(["LANGUAGE"])
    },
    methods: {
      emitSeek () {
        this.$validator.validateAll().then((result) => {
          result && this.$emit("seekDatePicker", this.formModel)
        })
      },
      getDate () {
        this.$parent.seekDatePicker.startDate = this.$moment().subtract(1, "days").format("YYYY-MM-DD")
        this.$parent.seekDatePicker.endDate = this.$moment().format("YYYY-MM-DD")
      },
      setSeekDropdown (index) {
        if (this.$parent.seekDropdownProps) {
          this.$parent.seekDropdownProps.active = index
        } else if (this.$parent.seekDropdown) {
          this.$parent.seekDropdown.active = index
        }
      }
    },
    components: {
      Dropdown,
      DatePicker
    }
  }
</script>

<style lang="scss" type="text/scss">
  .seekDatePicker{
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    .errText-wrapper {
      position: static;
      transform: translate(0,7px);
      left: 2px;
      bottom: -27px;
    }
    .span{
      display: inline-block;
      vertical-align: top;
      line-height: 36px;
      font-size: 13px;
    }
    .dropdown{
      display: inline-block;
      vertical-align: top;
      .input-date{
        display: inline-block;
        vertical-align: top;
        width: 106px;
        border-radius: 0;
      }
      .input-date1{
        border-bottom-left-radius: 3px;
        border-top-left-radius: 3px;
      }
      .date1{
        border-right: 0;
      }
      .date{
        border-left: 0;
        border-radius: 0;
      }
    }
    .btn-primary{
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// seekDatePicker.vue?1f0c03fc